<template>
  <div class="operations">
    <PageModal
      v-model:isOpen="isTypeHistoryOpen"
      :headerModel="{
        title: $gettext(details[selectedType].title),
        shadowed: true,
      }"
      duration="100"
    >
      <template #head>
        <div
          class="page-back-icon"
          :class="`${$isAndroid ? 'i-back-android' : 'i-back-ios'}`"
        ></div>
      </template>
      <template v-if="$isAndroid" #title>
        <div class="page-title text-left text-size-md font-medium w-full">
          {{ $t`Мой Банк` }}
        </div>
      </template>
      <OperationTypeHistory
        :operation="details[selectedType]"
        :type="selectedType"
        :dates="dates"
      />
    </PageModal>
    <div
      v-for="(operation, type) in details"
      :key="type"
      class="operations__item"
    >
      <ProductButton
        v-if="operation.amount > 0"
        :title="$gettext(operation.title)"
        @click="selectOperation(type)"
      >
        <template #tail>
          <div
            class="operations__amount"
            :class="{
              'text-green': !operation.is_expense,
            }"
          >
            <span>
              {{
                `${operation.is_expense ? "-" : "+"} ${$currencyFormatter(
                  Math.ceil(operation.amount)
                )}`
              }}
            </span>
            <div class="icon i-arrow"></div>
          </div>
        </template>
      </ProductButton>
    </div>
  </div>
</template>

<script>
import "@/jsdoc/types/statements";
import OperationTypeHistory from "@/components/dashboard/history/OperationTypeHistory.vue";
import ProductButton from "@/components/shared/button/ProductButton.vue";
import PageModal from "@/components/shared/modal/PageModal.vue";
import { ref } from "@vue/reactivity";

export default {
  props: {
    details: {
      /**
       * @type {import('vue').PropType<Details>}
       */
      type: Object,
      required: true,
    },
    dates: {
      /**
       * @type {import('vue').PropType<Dates>}
       */
      type: Object,
      required: true,
    },
  },
  components: {
    OperationTypeHistory,
    ProductButton,
    PageModal,
  },
  setup() {
    const isTypeHistoryOpen = ref(false);
    const selectedType = ref("OPER");

    function selectOperation(oper) {
      selectedType.value = oper;
      isTypeHistoryOpen.value = true;
    }

    return {
      isTypeHistoryOpen,
      selectedType,
      selectOperation,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/colors.scss";

.page-title {
  padding-left: 20px;
}

.operation-details {
  overflow: scroll;
  max-height: calc(100vh - 37px);
}

.operations {
  padding-top: 10px;

  &__item {
    margin-bottom: 1px;
  }

  &__amount {
    display: flex;
    align-items: center;

    .icon {
      margin-left: 22px;
    }

    &--positive {
      color: $colorGreen;
    }
  }
}
</style>
